<template>
  <ODialog ref="dialog" :maxWidth="900">
    <v-card v-if="row != null">
      <v-toolbar class="card-bar">
        <v-toolbar-title>
          Audio Set
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text class="pa-3 children-ma-3 v-row">
        <div>
          <v-text-field v-model="row.name" label="Nome" hide-details required />
        </div>

        <div>
          <v-simple-table dense fixed-header :height="450">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Slot</th>
                  <th>AudioMessage</th>
                  <th>Config Byte</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(slot, idx) in row.slots" :key="idx">
                  <td class="text-right">{{ slot.num }}</td>
                  <td>
                    <v-select
                      class="pa-0"
                      v-model="slot.audioMessageId"
                      clearable
                      :items="allMessages"
                      item-value="id"
                      item-text="name"
                      single-line
                      hide-details
                    />
                  </td>
                  <td>
                    <v-text-field
                      class="pa-0 text-right"
                      prefix="0x"
                      v-model="slot.configByte"
                      single-line
                      hide-details
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-card-text>

      <ODialogButtons
        class="pa-6"
        @apply="apply"
        @cancel="dismiss"
        @delete="remove"
        :show-delete="row.id != null"
      />
    </v-card>
  </ODialog>
</template>

<script>
import _ from 'lodash'
import { AudioMessage, AudioSet } from '@/models'

export default {
  mixins: [require('oderon-vue/cpts/dialog-promise-mixin').default],
  components: {
    ODialog: require('oderon-vue/cpts/ODialog').default,
    ODialogButtons: require('oderon-vue/cpts/ODialogButtons').default
  },
  data() {
    return {
      row: null,
      allMessages: []
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      let row = await AudioSet.findById(this.id)
      fillAndSortSlots(row)
      this.row = row

      this.allMessages = await AudioMessage.findAll()
    },

    apply() {
      this.$refs.dialog.$apply(this.row)
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    remove() {
      this.$refs.dialog.$apply('DELETE')
    }
  }
}

function fillAndSortSlots(audioSet) {
  if (audioSet.slots == null) audioSet.slots = []

  for (let i = 0; i < 10; i++) {
    if (!audioSet.slots.find(s => s.num == i)) audioSet.slots.push({ num: i })
  }

  audioSet.slots = _.sortBy(audioSet.slots, 'num')
  return audioSet
}
</script>

<style></style>
